import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {InsolesModel} from '../../../api/model/insoles.model';
import {InsolesConverter} from '../../../api/model/insoles.converter';
import {InsolesDataService} from './insoles.data.service';

@Injectable()
export class InsolesDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<InsolesModel, InsolesConverter> {
    constructor(dataService: InsolesDataService, converter: InsolesConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): InsolesModel {
        return new InsolesModel();
    }
}
